import { z } from "zod";

// Skema untuk data utama dalam tatasusunan 'data'
const SalesMonthlyDataV4Schema = z.object({
    month: z.string(),
    source_id: z.string().nullable(),
    name: z.string(),
    color: z.string(),
    total_earning: z.string(),
});

// Skema untuk tatasusunan 'total_source'
const TotalSourceV4Schema = z.object({
    source_id: z.string().nullable(),
    name: z.string(),
    color: z.string(),
    total_earning: z.string(),
});

// Skema untuk tatasusunan 'total_month'
const TotalMonthV4Schema = z.object({
    month: z.string(),
    total_earning: z.string(),
});

// Skema respons API utama
export const ReportSalesMonthlyResponseV4Schema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number().int(),
    data: z.array(SalesMonthlyDataV4Schema),
    total_source: z.array(TotalSourceV4Schema),
    total_month: z.array(TotalMonthV4Schema),
    total: z.string(), // Jumlah keseluruhan adalah rentetan
});

export type SalesMonthlyDataV4 = z.infer<typeof SalesMonthlyDataV4Schema>;
export type ReportSalesMonthlyResponseV4 = z.infer<typeof ReportSalesMonthlyResponseV4Schema>;